import Utils from '@/providers/Utils'

export default {

    // -------- tool options ----------

    toolName: 'behaviorReport',
    label: 'DBR Maker',
    logo: 'Behavior-Report-logo-32.png',

    getDefaultData() {
        return {
            docTitle: 'Untitled',
            currentStep: 1,
            fontFace: 'sans',
            fontSize: 'small',

            cardTitle: null,
            studentName: null,
            raterName: null,

            ratingItems: [],

            tabIndex: 0,
        }
    },

    steps: [
        {id: 1, title: 'Header information'},
        {id: 2, title: 'Rating items & response formats'},
        {id: 3, title: 'Reporting period'},
    ],

    // define which download methods are supported - see ToolContainerPreviewToolbar::inject
    provide: function() {
        return {
            downloadDocFile: null,
            downloadPdfFile: null,
            exportToGoogleForms: null,
        }
    },

}
